module.exports = __webpack_public_path__ + "static/media/payoneer.e6558fdc.jpeg";